'use client';

import '@ui5/webcomponents/dist/ComboBox.js';
import { ComboBoxFilter, ValueState } from '../../enums/index.js';
import { withWebComponent } from '../../internal/withWebComponent.js';
/**
 * The `ComboBox` component represents a drop-down menu with a list of the available options and a text input field to narrow down the options. It is commonly used to enable users to select an option from a predefined list.
 *
 * __Note:__ This component is a web component developed by the UI5 Web Components’ team.
 *
 * [UI5 Web Components Storybook](https://sap.github.io/ui5-webcomponents/playground/?path=/docs/main-ComboBox)
 */
const ComboBox = withWebComponent('ui5-combobox', ['accessibleName', 'accessibleNameRef', 'filter', 'placeholder', 'value', 'valueState'], ['disabled', 'loading', 'noTypeahead', 'readonly', 'required'], ['icon', 'valueStateMessage'], ['change', 'input', 'selection-change']);
ComboBox.displayName = 'ComboBox';
ComboBox.defaultProps = {
  filter: ComboBoxFilter.StartsWithPerTerm,
  valueState: ValueState.None
};
export { ComboBox };